<template>
  <!-- eslint-disable-next-line vue/no-root-v-if -->
  <component :is="'style'">
    :root {
    {{ themeCss }}
    }
  </component>
</template>

<script>
import { mapGetters } from "vuex";
import { getButtonThemeVars } from "@/utils/whiteLabelColors";

export default {
  name: "WhiteLabelTheme",
  computed: {
    ...mapGetters({
      marketInfo: "user/marketInfo",
    }),
    themeCss() {
      const vars = getButtonThemeVars(this.marketInfo);
      return Object.entries(vars)
        .map(([name, value]) => `${name}:${value};`)
        .join("");
    },
  },
};
</script>
